/*
	Функция для рендера стоимости
	Принимает в себя число и валюту.
	Пример использования:
	decl(15, 'баксов');
*/
export default function price(number = 0, VAT = false, currency = 'руб.') {
  const options = {
    maximumFractionDigits: 0
  };
  const render = `${new Intl.NumberFormat('ru-RU',options).format(number)} ${currency} ${VAT ? 'с НДС' : ''}`;
  return render;
}
